export enum WorkType {
  Onsite = 'onsite',
  Remote = 'remote',
  Hybrid = 'hybrid'
}

export function getWorkTypeLabel(workType: WorkType): string {
  switch (workType) {
    case WorkType.Onsite:
      return 'Onsite';
    case WorkType.Remote:
      return 'Remote';
    case WorkType.Hybrid:
      return 'Hybrid';
    default:
      return 'Unknown';
  }
}

export function getWorkTypeOptions(): { value: WorkType; label: string }[] {
  return [
    { value: WorkType.Onsite, label: getWorkTypeLabel(WorkType.Onsite) },
    { value: WorkType.Remote, label: getWorkTypeLabel(WorkType.Remote) },
    { value: WorkType.Hybrid, label: getWorkTypeLabel(WorkType.Hybrid) }
  ];
}

export function validateWorkType(workType: WorkType): boolean {
  return Object.values(WorkType).includes(workType);
}
